import { ReactNode, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { PathnameUrl } from "@app/constants";

/*
 * Khung chung của trang Giới thiệu, Liên hệ (bản thiết kế introduce.ejs / contact.ejs) và Điều khoản:
 * đầu trang có menu Thông tin, đường dẫn "Trang chủ / …", chân trang.
 * Nằm ngoài khung app như /home.
 * Thẻ description nằm sẵn trong public/index.html, không thêm thẻ thứ 2.
 */

const NAV: [string, string][] = [
  [PathnameUrl.INTRODUCE, "Giới thiệu"],
  [PathnameUrl.CONTACT, "Liên hệ"],
  [PathnameUrl.TERMS, "Điều khoản"],
];

interface Props {
  current: string;
  title: string;
  docTitle: string;
  children: ReactNode;
}

function InfoLayout({ current, title, docTitle, children }: Props) {
  // mở từ chân trang chủ thì trình duyệt giữ vị trí cuộn cũ: đưa về đầu trang.
  // Link có #mục (vd /term-of-service#thanh-toan) thì cuộn tới mục đó, vì trang vẽ sau khi trình duyệt tìm #.
  useEffect(() => {
    const hash = decodeURIComponent(window.location.hash.slice(1));
    const target = hash && document.getElementById(hash);

    if (target) target.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [current]);

  return (
    <div className="ip-page min-h-screen bg-bg text-fg">
      <Helmet>
        <title>{docTitle}</title>
        <link rel="canonical" href={`https://pcrender.com${current}`} />
      </Helmet>

      <header className="top">
        <div className="wrap">
          <Link
            className="logo"
            to="/home"
            aria-label="PC Render, về trang chủ"
          >
            <span>PC</span>Render
          </Link>
          <nav className="nav" aria-label="Thông tin">
            <Link to="/home">Trang chủ</Link>
            {NAV.map(([to, label]) => (
              <Link
                key={to}
                to={to}
                aria-current={to === current ? "page" : undefined}
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>
      </header>

      <main>
        <div className="wrap">
          <div className="crumb">
            <Link to="/home">Trang chủ</Link> / {title}
          </div>
          {children}
        </div>
      </main>

      <footer>
        <div className="wrap">
          <span>© CÔNG TY TNHH CÔNG NGHỆ PCRENDER</span>
          <span>
            <Link to={PathnameUrl.INTRODUCE}>Giới thiệu</Link> ·{" "}
            <Link to={PathnameUrl.CONTACT}>Liên hệ</Link> ·{" "}
            <Link to={PathnameUrl.TERMS}>Điều khoản</Link>
          </span>
        </div>
      </footer>
    </div>
  );
}

export default InfoLayout;
